import './scss/main.scss';

import CardMenu from './js/card-menu.js';
import Searcher from './js/searcher.js';
import SearchLinker from './js/search-linker.js';
import SearchPagination from './js/search-pagination.js';

// Конфигурация
const config = {
    debug: __APP_DEBUG__ === 'true',
    apiUrl: __APP_API_URL__,
    apiPopulars: __APP_API_POPULARS__,
    apiSearch: __APP_API_SEARCH__,
    apiLink: __APP_API_LINK__,
    apiReport: __APP_API_REPORT__,
    apiPromoteInfo: __APP_API_PROMOTE_INFO__,
    apiPromote: __APP_API_PROMOTE__,
    promoteAgreementUrl: __APP_PROMOTEAGREEMENT_URL__,
    messages: {
        // CardMenu
        reportSuccess: 'Спасибо за сообщение о проблеме с сайтом {domain}',
        // Результаты поиска
        noResultsTitle: 'По запросу "{query}" ничего не найдено.',
        noResultsHint: 'Попробуйте изменить запрос или использовать другие ключевые слова.',
        popularQueriesTitle: 'Популярные запросы сегодня:',
        errorTitle: 'Произошла ошибка при загрузке результатов.',
        errorHint: 'Пожалуйста, попробуйте позже.',
        loadMore: 'Загрузить ещё',
        loading: 'Идёт загрузка...'
    }
};

// Инициализация модулей
const cardMenu = new CardMenu('[data-card-menu-template]', {
    debug: config.debug,
    apiEndpoint: config.apiReport,
    messages: config.messages,
    apiPromoteInfo: config.apiPromoteInfo,
    apiPromote: config.apiPromote,
    promoteAgreementUrl: config.promoteAgreementUrl,
});

const searcher = new Searcher({
    debug: config.debug,
    apiUrl: config.apiUrl,
    apiPopulars: config.apiPopulars,
    debounceDelay: 220,
    popularsDelay: 2000
});

const linker = new SearchLinker('.results__cards', {
    debug: config.debug,
    apiEndpoint: config.apiLink
});

const pagination = new SearchPagination({
    debug: config.debug,
    apiEndpoint: config.apiSearch,
    apiPopulars: config.apiPopulars,
    resultsPerPage: 10,
    maxPaginationLinks: 5,
    messages: config.messages
});

// Переключение режимов
const mainpage = document.querySelector('.mainpage');

function showResults() {
    // mainpage.classList.remove('_search-mode');
    mainpage.classList.add('mainpage_results');
}

function showSearch() {
    mainpage.classList.remove('mainpage_results');
    // mainpage.classList.add('_search-mode');
}

// Обработка поиска
const searchButton = document.querySelector('[data-searcher-button]');
const searchInput = document.querySelector('[data-searcher-input]');

if (searchButton && searchInput) {
    searchButton.addEventListener('click', () => {
        const query = searchInput.value.trim();
        if (query) {
            showResults();
            pagination.loadResults(query, 1, true);
        }
    });

    searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            searchButton.click();
        }
    });
}

// Мобильная подгрузка (Load More)
const loadMoreButton = document.querySelector('[data-load-more-button]');
const loadMoreContainer = document.querySelector('.results__load-more');

if (loadMoreButton) {
    loadMoreButton.addEventListener('click', async () => {
        if (pagination.isLoading) return;
        if (pagination.currentPage >= pagination.totalPages) return;

        loadMoreContainer.classList.add('_loading');

        const nextPage = pagination.currentPage + 1;
        await pagination.loadMoreResults(pagination.currentQuery, nextPage);

        loadMoreContainer.classList.remove('_loading');

        // Скрыть кнопку если это последняя страница
        if (pagination.currentPage >= pagination.totalPages) {
            loadMoreContainer.style.display = 'none';
        }
    });
}

// При загрузке страницы проверяем URL
window.addEventListener('DOMContentLoaded', () => {
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get('q');

    if (query) {
        if (searchInput) {
            searchInput.value = query;
        }
        showResults();
        // Restore button states after page reload
        if (searchButton) {
            searchButton.classList.add('_searched');
        }
        const clearButton = document.querySelector('[data-searcher-clear]');
        if (clearButton && query.trim()) {
            clearButton.classList.add('_active');
        }
        // Загружаем результаты и снимаем прелоадер после завершения
        pagination.loadResults(query, 1, true).finally(() => {
            document.documentElement.classList.add('initialized');
        });
    } else {
        // Нет запроса — сразу снимаем прелоадер
        document.documentElement.classList.add('initialized');
    }
});

// Export functions for pagination to use
window.showSearchResults = showResults;
window.showSearchMode = showSearch;

// Export handles for cross-module communication
window.searcherHandle = searcher;
window.searchLinkerHandle = linker;